export enum GridNavigationType {
  KEY_LEFT = 'ArrowLeft',
  KEY_UP = 'ArrowUp',
  KEY_RIGHT = 'ArrowRight',
  KEY_DOWN = 'ArrowDown',
  TAB_TO_NEXT_CELL = 'TabToNextCell'
}
